
import { Component, PropSync, Vue } from 'nuxt-property-decorator'
import AppModal from '~/components/AppModal/AppModal.vue'
import GoogleRating from '~/components/widgets/GoogleRating.vue'

@Component({
  components: {
    AppModal,
    GoogleRating,
  },
})
export default class B2bFormModal extends Vue {
  @PropSync('show', { type: Boolean, default: false, required: true })
  isShow!: boolean

  get modalImages () {
    return [
      require('~/assets/images/b2b/modal.png'),
      require('~/assets/images/b2b/modal@2x.png'),
    ]
  }

  get modalImagesStr () {
    return `${this.modalImages[0]} 1x, ${this.modalImages[1]} 2x`
  }
}
